var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropdown-menu p-0",class:_vm.isFull ? 'w-100' :'w-67-perc'},[_c('div',{staticClass:"dropdown-menu-container test-img-category-container"},[_c('category-panel-nav-bar-tabs',{ref:"navBarTab",attrs:{"categories":_vm.categories,"title":'Categorie'},on:{"levelChange":_vm.onLevelChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }